
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Mistralairplusservice() {



  const cardData =
  {
    keyword: 'Mistral Air Plus Service Warmer Machine',
    heading: 'Pharmacle Health Care Private Limited: Mistral Air Plus Service Warmer Machine',
    headingDescription: 'Pharmacle Health Care Private Limited is a trusted provider of advanced thermal care solutions, including the Mistral-Air® Plus Service Warmer Machine, designed to maintain optimal patient body temperature during surgical and critical care procedures. Our state-of-the-art warming systems utilize forced-air technology to deliver consistent and controlled heat, effectively preventing hypothermia and enhancing patient safety. Trusted by top hospitals and healthcare facilities across India, our systems are user-friendly, reliable, and integrate seamlessly into various clinical settings. Choose Pharmacle Health Care for superior patient warming systems that elevate the standard of care and improve clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Mistral-Air® Plus Warming Unit – Reliable Forced-Air Warming Solution",
    "description": "The Mistral-Air® Plus Service Warmer Machine is a highly efficient forced-air warming unit designed to maintain normothermia in surgical and critical care patients. Equipped with a HEPA H13 filter, it ensures 99.95% filtration efficiency and features four temperature settings—ambient, 32°C, 38°C, and 43°C. The device supports controlled heat diffusion via Mistral-Air® warming blankets and comes with a service indicator that activates after 2,000 hours of use."
  },
  {
    "title": "Service Features of the Mistral-Air® Plus Warmer Machine",
    "description": "The Mistral-Air® Plus unit includes a built-in service alert system that notifies technicians when maintenance is required. Recommended service includes HEPA filter replacement, temperature calibration check, and internal cleaning by a certified biomedical technician. These measures ensure optimal performance and extend the life of the unit."
  },
  {
    "title": "Mistral-Air® Service Manual – Essential Maintenance Guidelines",
    "description": "The official technical manual for the Mistral-Air® Plus Warmer provides comprehensive service guidelines, including diagnostics, error code explanations, and step-by-step instructions for filter replacement and temperature sensor recalibration. Annual servicing is strongly recommended to maintain safety compliance and device accuracy."
  },
  {
    "title": "The Surgical Company – Manufacturer of Mistral-Air® Systems",
    "description": "The Surgical Company International B.V. is the original equipment manufacturer (OEM) of the Mistral-Air® product line. Known for their commitment to clinical innovation, they provide high-performance patient warming systems, including the Mistral-Air® Plus, with global support and documentation."
  },
  {
    "title": "Hansraj Nayyar Medical India – Authorized Distributor for Mistral-Air® in India",
    "description": "Hansraj Nayyar Medical India Pvt. Ltd. is an authorized distributor of the Mistral-Air® Plus system and accessories, including blankets and service kits. They provide on-site support, warranty handling, and spare part availability for Indian hospitals and surgical centers."
  },
  {
    "title": "HospitalStore.in – Supplier of Mistral-Air® Units and Accessories",
    "description": "HospitalStore.in stocks the Mistral-Air® Plus Warmer Machine and compatible accessories including full-body, upper-body, and underbody blankets. The platform offers fast delivery across India and includes after-sales service options for preventive maintenance and repairs."
  },
  {
    "title": "Infimedix – Service Provider for Mistral-Air® Heat Therapy Devices",
    "description": "Infimedix supports Mistral-Air® users with service contracts, maintenance, and supply of consumables. They offer annual calibration services, filter replacements, and full system diagnostics for the Mistral-Air® Plus and MA1200 models."
  },
  {
    "title": "Duomed – European Supplier and Technical Support Partner",
    "description": "Duomed offers comprehensive support for the Mistral-Air® system including training, installation, and servicing. Their technical experts assist healthcare teams with proper maintenance and operational efficiency, reducing device downtime in critical care settings."
  },
  {
    "title": "Anandic Medical Systems – Technical Support for Mistral-Air® Devices",
    "description": "Anandic Medical Systems provides technical services, spare parts, and software upgrades for the Mistral-Air® Plus. Their certified engineers are trained to perform full service diagnostics and preventive maintenance according to manufacturer standards."
  },
  {
    "title": "Stryker – Global Distributor and Service Partner for Mistral-Air®",
    "description": "Stryker, a global healthcare company, distributes and supports the Mistral-Air® product line in many markets. They offer extended warranty plans, training programs, and quick turnaround on service calls for hospitals using the Mistral-Air® Plus Warming Unit."
  }
],

"services": [
    {
        "name": "Mistral Air Plus Service Warmer Machine",
        "description": "Pharmacle Health Care offers the Mistral Air Plus Service Warmer Machine, an advanced solution for maintaining normothermia in surgical and post-operative settings. This machine delivers consistent convective air warming to prevent hypothermia, ensuring improved patient safety, comfort, and recovery outcomes. It is built for precision, reliability, and ease of use in demanding clinical environments."
    },
    {
        "name": "Mistral Air Plus Surgical Blanket Warmer",
        "description": "The Mistral Air Plus Surgical Blanket Warmer is designed to keep patients warm during surgical procedures using controlled forced air technology. Compatible with Mistral blankets, this system supports thermal stability throughout operations, reducing complications and enhancing surgical outcomes. It is an essential tool in modern operating rooms focused on advanced patient care."
    },
    {
        "name": "Mistral Air Plus Thermoregulation Equipment",
        "description": "Pharmacle Health Care supplies Mistral Air Plus Thermoregulation Equipment, engineered to provide precise temperature control during surgeries and recovery. These systems help regulate and maintain core body temperature, preventing perioperative hypothermia and supporting improved patient outcomes. Ideal for ORs, ICUs, and critical care units, they deliver effective and safe warming performance."
    },
    {
        "name": "Mistral Advanced Warming Systems",
        "description": "We offer Mistral Advanced Warming Systems, designed for use in a variety of clinical settings where body temperature control is critical. These systems combine intelligent airflow, customizable settings, and ergonomic design to provide effective warming across surgical and recovery phases. They help medical teams achieve optimal thermoregulation standards for patients."
    },
    {
        "name": "Mistral Air Plus Patient Heating Device",
        "description": "The Mistral Air Plus Patient Heating Device provides consistent convective warming to support temperature management during medical procedures. Designed with safety and performance in mind, this device helps maintain ideal patient body temperature, reducing the risk of complications and improving recovery experiences. It is compatible with a wide range of clinical blankets and settings."
    },
    {
        "name": "Mistral Air Plus Forced Air Warming System",
        "description": "Pharmacle Health Care supplies the Mistral Air Plus Forced Air Warming System, built for maintaining safe and steady body temperature in perioperative care. Using advanced forced air circulation, it ensures even heat distribution through compatible warming blankets, making it an indispensable part of surgical temperature management protocols."
    },
    {
        "name": "Operating Room Blanket Warmer Mistral Air Plus",
        "description": "Our Operating Room Blanket Warmer Mistral Air Plus is specifically engineered for use in surgical environments. It delivers rapid, uniform warming through high-efficiency air output, ensuring patient thermal stability during operations. With intuitive controls and safety features, it supports both patient comfort and optimal surgical conditions."
    }
],
"tableData": [
    ["- Mistral Air Plus Service Warmer Machine", "- Mistral Air Plus Surgical Blanket Warmer"],
    ["- Mistral Air Plus Thermoregulation Equipment", "- Mistral Advanced Warming Systems"],
    ["- Mistral Air Plus Patient Heating Device", "- Mistral Air Plus Forced Air Warming System"],
    ["- Operating Room Blanket Warmer Mistral Air Plus"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Precise Warming Technology",
        "WhyChoosedescription": "The Mistral Air Plus Service Warmer Machine delivers advanced convective warming with precise temperature control, ensuring optimal patient care during surgery and post-operative recovery. It helps maintain normothermia and significantly reduces the risk of hypothermia-related complications."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solution",
        "WhyChoosedescription": "This system is part of a full-featured warming solution designed for diverse clinical environments. The Mistral Air Plus Service Warmer Machine works seamlessly with various warming blankets to provide tailored thermal management for different surgical procedures and patient needs."
    },
    {
        "WhyChooseheading": "Durable and Reliable Medical Equipment",
        "WhyChoosedescription": "Built to withstand the demands of modern healthcare environments, the Mistral Air Plus Service Warmer Machine offers durability and dependable performance. Its robust design ensures long-term reliability, making it a trusted choice in hospitals and surgical centers."
    },
    {
        "WhyChooseheading": "Enhanced Patient Safety and Comfort",
        "WhyChoosedescription": "With multiple temperature settings and safety mechanisms, the Mistral Air Plus ensures gentle, evenly distributed warmth for patients. It minimizes the risks of overheating or uneven heating, providing safe and comfortable thermal support during critical procedures."
    },
    {
        "WhyChooseheading": "Adaptable to Various Clinical Settings",
        "WhyChoosedescription": "Whether used in operating rooms, ICUs, or recovery wards, the Mistral Air Plus Service Warmer Machine adapts effortlessly. Its lightweight design, intuitive controls, and compatibility with a wide range of warming blankets make it ideal for versatile hospital use."
    },
    {
        "WhyChooseheading": "Seamless Integration with Hospital Systems",
        "WhyChoosedescription": "Designed for integration into existing medical infrastructure, the Mistral Air Plus Warmer operates efficiently without disrupting hospital workflows. It fits easily into surgical routines, ensuring smooth, uninterrupted care delivery."
    },
    {
        "WhyChooseheading": "Professional Support and Maintenance Services",
        "WhyChoosedescription": "We offer expert consultation, installation, and maintenance services for the Mistral Air Plus Service Warmer Machine. Our dedicated support team ensures your device remains in peak working condition, with timely service and troubleshooting."
    },
    {
        "WhyChooseheading": "Commitment to Quality and Patient Outcomes",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, we are committed to delivering innovative and safe warming solutions. The Mistral Air Plus Service Warmer Machine supports improved surgical outcomes by maintaining patient temperature stability with cutting-edge thermal technology."
    }
]























  }

  const faqData = [
    {
      question: "What is the Mistral Air Plus Service Warmer Machine?",
      answer: "The Mistral Air Plus Service Warmer Machine is a forced-air warming system designed to maintain a patient's body temperature during surgical procedures. It uses warm, filtered air circulated through a specially designed blanket to prevent hypothermia."
    },
    {
      question: "How does the Mistral Air Plus Service Warmer Machine work?",
      answer: "The system operates by drawing in ambient air, heating it, and delivering it through a hose to a warming blanket placed on the patient. The temperature can be adjusted using the control panel, with settings typically at 32°C, 38°C, or 43°C."
    },
    {
      question: "Is the Mistral Air Plus Service Warmer Machine suitable for all types of surgeries?",
      answer: "Yes, the Mistral Air Plus Service Warmer Machine is versatile and can be used in various surgical procedures where maintaining normothermia is crucial for patient safety and recovery."
    },
    {
      question: "What are the key features of the Mistral Air Plus Service Warmer Machine?",
      answer: "Key features include fast warming at the push of a button, smart warming with even heat distribution, high-efficiency filtration, sensors and alarms for trusted patient warming, and ergonomic design for easy integration into surgical environments."
    },
    {
      question: "Where can I purchase the Mistral Air Plus Service Warmer Machine in India?",
      answer: "The Mistral Air Plus Service Warmer Machine is available through authorized distributors and medical equipment suppliers in India. It's advisable to contact TSC Life or their official distributors for purchasing information."
    }
  ];
  
  const testimonialsData = [
    {
      text: "The Mistral Air Plus Service Warmer Machine has significantly improved our ability to maintain patient body temperature during surgeries, leading to better patient outcomes.",
      name: "Dr. Rajesh Kumar, MediCare Hospital"
    },
    {
      text: "We have been using the Mistral Air Plus Service Warmer Machine in our clinic, and it has proven to be reliable and effective in preventing hypothermia during procedures.",
      name: "Dr. Priya Mehta, City Clinic"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  
  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Mistral Air Plus Service Warmer Machine",
    "description": "Mistral Air Plus Service Warmer Machine delivers advanced patient warming with surgical blanket heaters, thermoregulation systems, and forced air technology for optimal temperature control in operating rooms and hospitals.",
    "brand": {
      "@type": "Brand",
      "name": "Mistral Air Plus"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "1026"
    }
  };
  
 

  return (
    <div>
 <Helmet>
    <title>Mistral Air Plus Service Warmer Machine | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore the Mistral Air Plus Service Warmer Machine for surgical patient heating. Includes advanced warming systems, forced air blanket warmers, and hospital thermoregulation devices. Call +91 8956322311."
    />
    <meta
      name="keywords"
      content="Mistral Air Plus Service Warmer Machine, Mistral Air Plus Surgical Blanket Warmer, Mistral Air Plus Thermoregulation Equipment, Mistral Advanced Warming Systems, Mistral Air Plus Patient Heating Device, Mistral Air Plus Forced Air Warming System, Operating Room Blanket Warmer Mistral Air Plus"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  

  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/58.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mistralairplusservice;